import MultiPartScoreBadge from './MultiPartScoreBadge';

export default MultiPartScoreBadge;
export { MultiPartScoreBadge };
